import { render } from "./TowersGame.vue?vue&type=template&id=2a82e298&scoped=true"
import script from "./TowersGame.vue?vue&type=script&lang=js"
export * from "./TowersGame.vue?vue&type=script&lang=js"

import "./TowersGame.vue?vue&type=style&index=0&id=2a82e298&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a82e298"]])

export default __exports__